var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("markdown-it-vue", {
    ref: "markdownItVue",
    class: { isCollapse: _vm.isCollapse },
    attrs: { content: _vm.content, options: { markdownIt: { breaks: true } } },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }